import { createSelector } from 'reselect';
import { ApplicationState } from '../../reducers';

const getDeliveryLogResources = (state: ApplicationState) =>
  state.channel.logs.deliveryLogResources;

export const getDeliveryLogResourcesWithUniqueChannelPlans = createSelector(
  [getDeliveryLogResources],
  resources => {
    if (!resources) return resources;

    const channelPlans = resources.channel_plans || [];
    const uniqueChannelPlans = (Array.from(new Set(channelPlans)) as string[]).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    );

    return {
      ...resources,
      channel_plans: uniqueChannelPlans,
    };
  }
);
